/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { RegexCompat } from '../../compat/RegexCompat';
import { IIndexedNode } from '../models/IIndexedNode';
import { Node } from '../models/Node';
import { IReferenceResolver } from './IReferenceResolver';
import { Document } from '../models/Document';

/**
 * A class to help with resolving references.  Handles recursion with loop detection.
 * @author eric.wittmann@gmail.com
 * @class
 */
export class LocalReferenceResolver implements IReferenceResolver {
    /**
     * @see io.apicurio.datamodels.core.util.IReferenceResolver#resolveRef(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} $ref
     * @param {Node} from
     * @return {Node}
     */
    public resolveRef($ref : string, from : Node) : Node {
        if($ref == null || $ref.indexOf("#/") !== 0) {
            return null;
        }
        let split : Array<string[]> = RegexCompat.findMatches($ref, "([^/]+)/?");
        let cnode : any = null;
        for(let index195=0; index195 < split.length; index195++) {
            let mi = split[index195];
            {
                let seg : string = mi[1];
                if(NodeCompat.equals(seg, "#")) {
                    cnode = from.ownerDocument();
                } else if(cnode != null) {
                    if(cnode != null && (cnode["__interfaces"] != null && cnode["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IIndexedNode") >= 0 || cnode.constructor != null && cnode.constructor["__interfaces"] != null && cnode.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.IIndexedNode") >= 0)) {
                        cnode = (<IIndexedNode<any>><any>cnode).getItem(seg);
                    } else {
                        cnode = NodeCompat.getProperty(cnode, seg);
                    }
                }
            }
        }
        if(cnode != null && cnode instanceof <any>Node) {
            return <Node>cnode;
        } else {
            return null;
        }
    }

    constructor() {
    }
}
LocalReferenceResolver["__class"] = "io.apicurio.datamodels.core.util.LocalReferenceResolver";
LocalReferenceResolver["__interfaces"] = ["io.apicurio.datamodels.core.util.IReferenceResolver"];




